import React, { useMemo } from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { Capacitor } from '@capacitor/core';
import { useAuth } from '../context/AuthContext';

const { Text } = Typography;

const GeofenceStatusBanner = () => {
  const { auth, operator, geofenceStatus, geofenceLoading, geofenceError, refreshGeofence } = useAuth();
  const isNative = useMemo(() => Capacitor.isNativePlatform(), []);

  if (!auth || !operator) return null;

  if (geofenceStatus?.inside === true) return null;

  const message = geofenceError
    ? 'Location check failed'
    : 'Outside office location';

  const description = geofenceError
    ? geofenceError
    : 'Please move to an authorized office location to continue.';

  const type = isNative ? 'error' : 'warning';

  return (
    <div className="container" style={{ maxWidth: 1400, margin: '12px auto 0 auto' }}>
      <Alert
        showIcon
        type={type}
        message={message}
        description={
          <Space direction="vertical" size={6} style={{ width: '100%' }}>
            <Text>{description}</Text>
            <Button onClick={() => refreshGeofence(true)} loading={geofenceLoading} size="small">
              Retry Location Check
            </Button>
          </Space>
        }
      />
    </div>
  );
};

export default GeofenceStatusBanner;

